import { render } from "./PrepareMeetingInvitation.vue?vue&type=template&id=2775b4e8&scoped=true"
import script from "./PrepareMeetingInvitation.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./PrepareMeetingInvitation.vue?vue&type=script&charset=utf-8&lang=js"

import "./PrepareMeetingInvitation.vue?vue&type=style&index=0&id=2775b4e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2775b4e8"]])

export default __exports__